import React, { Fragment, FC } from 'react';
import {
  Box,
  SideSheet,
  SideSheetHeader,
  SideSheetClose,
  SideSheetSubHeader,
  SideSheetBody,
  SideSheetContentCol,
} from '@bechtel/gds';
import { TitleValue } from '@bechtel/client-common';
import { t } from '@lingui/macro';
import { ReclaimProps } from './types';
import { Reclaim } from './index';
import { MilestoneStatusCode } from '@bechtel/types';

export const ReclaimSideSheet: FC<ReclaimProps> = ({ milestone, closeModal, showSubHeader = true, refetchQueries }) => {
  return (
    <Fragment>
      <SideSheet visible closable onDismiss={closeModal}>
        <SideSheetHeader
          data-testid="attachment-header"
          title={milestone?.currentStatus?.codeI18n == MilestoneStatusCode.REJECTED ? t`Reclaim` : t`Claim`}
        >
          <SideSheetClose onClick={closeModal}></SideSheetClose>
        </SideSheetHeader>
        {showSubHeader && (
          <SideSheetSubHeader>
            <Box mr={{ sm: '300' }}>
              <TitleValue title={t`Milestone`} value={milestone.name}></TitleValue>
            </Box>
          </SideSheetSubHeader>
        )}
        <SideSheetBody>
          <SideSheetContentCol style={{display: 'flex', flexDirection: 'column'}}>
            <Reclaim
              milestone={milestone}
              closeModal={closeModal}
              refetchQueries={refetchQueries}
              showSubHeader={!showSubHeader}
            />
          </SideSheetContentCol>
        </SideSheetBody>
      </SideSheet>
    </Fragment>
  );
};
